export const reshapeWords = (words) => {
  const turnWordsToArray = words.split('-');
  turnWordsToArray.splice(1, 1);
  const newWord = turnWordsToArray.join('').split(' ');
  newWord.pop();

  return newWord.join(' ');
};
